import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import Button from '../../../components/UI/Button/Button'
import DatePicker from '../../../components/UI/DatePicker/DatePicker'
import Search from '../../../components/UI/Search/Search'
import Select from '../../../components/UI/Select/Select'
import Table from "../../../components/UI/Table/Table"
import FetchData from '../../../shared/fetchData'
import './InvoiceReports.css'

const InvoiceReports = (props) => {

    const [from, setFrom] = React.useState('')
    const [to, setTo] = React.useState('')
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [units, setUnits] = React.useState([])
    const [unit, setUnit] = React.useState('')
    const [invoices, setInvoices] = React.useState([])

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
        var raw = JSON.stringify({
            "unit": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setUnits(result.units)
                }
            })
            .catch(error => console.log(error))
        var raw = JSON.stringify({
            "lockerType": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
    }, [])

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "filter": {
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
                "buyerId": unit != null && unit != '' ? unit.value : null,
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/invoices/getInvoices'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.invoices)
                    pushData(newList)
                    setInvoices(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'registerDate',
                header: 'تاریخ فاکتور',
                align: 'center',
            },
            {
                accessorKey: 'fromDate',
                header: 'از تاریخ',
                align: 'center',
            },
            {
                accessorKey: 'toDate',
                header: 'تا تاریخ',
                align: 'center',
            },
            {
                accessorKey: 'serial',
                header: 'سریال',
                align: 'center',
            },
            {
                accessorKey: 'description',
                header: "شرح فاکتور",
                align: 'center',
            },
            {
                accessorKey: 'sellerName',
                header: "فروشنده",
                align: 'center',
            },
            {
                accessorKey: 'endDate',
                header: "خریدار",
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                registerDate: d.registerDate,
                fromDate: d.fromDate,
                toDate: d.toDate,
                serial: d.serial,
                description: d.description,
                sellerName: d.sellerName,
                buyerName: d.buyerName,
                subRows: [
                    { header: 'هزینه باکس', value: d.lockerAmount ? d.lockerAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' },
                    { header: 'مالیات', value: !!d.taxAmount ? d.taxAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' },
                    { header: 'مبلغ کل', value: !!d.invoiceAmount ? d.invoiceAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' },
                ],
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }
    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }
    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }
    const refresh = (event) => {
        setFrom('')
        setTo('')
        setUnit('')
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }
    const afterCloseModal = (event) => {
    }
    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
                "buyerId": unit != null && unit != '' ? unit.value : null,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/invoices/getInvoices'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportInvoiceReport = []
                    let count = 0
                    const invoiceReport = result.invoices.map(o => {
                        count++
                        exportInvoiceReport.push({
                            'ردیف': count,
                            'تاریخ فاکتور': o.registerDate,
                            'از تاریخ': o.fromDate,
                            'تا تاریخ': o.toDate,
                            'سریال': o.serial,
                            "شرح فاکتور": o.description,
                            "فروشنده": o.sellerName,
                            "خریدار": o.buyerName,
                            "هزینه باکس": o.lockerAmount,
                            "مالیات بر ارزش افزوده": o.taxAmount,
                            "مبلغ کل": o.invoiceAmount
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportInvoiceReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'InvoiceReports' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }
    const changeUnit = selectedOption => {
        setUnit(selectedOption)
    }
    const unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }
    let form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <div className="col-4 small-ord-col">
                <DatePicker change={changeFromDate} value={from} placeHolder="از تاریخ" />
            </div>
            <div className="col-4 small-ord-col">
                <DatePicker change={changeToDate} value={to} placeHolder="تا تاریخ" />
            </div>
            <Select
                name="form-field-name"
                value={unit}
                placeholder="حساب"
                options={unitList}
                onChange={changeUnit}
                col="4"
            />
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>
    return (
        <div className="third-invoiceReports">
            <Search class="orders-search" form={form} />
            {rerender ?
                // <Spinner />
                <Table pageSize={pageSize} data={invoices} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                :
                <Table pageSize={pageSize} data={invoices} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
            }
        </div>
    )
}
export default InvoiceReports